module.exports = __webpack_public_path__ + "static/media/11n.1aba0804.png";